import { useEffect, useRef } from 'react';

export const CustomCursor = () => {
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);
  
  useEffect(() => {
    const cursor = cursorRef.current;
    const cursorDot = cursorDotRef.current;
    let currentX = 0;
    let currentY = 0;
    let aimX = 0;
    let aimY = 0;

    const animate = () => {
      currentX += (aimX - currentX) * 0.2;
      currentY += (aimY - currentY) * 0.2;

      cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      cursorDot.style.transform = `translate3d(${aimX}px, ${aimY}px, 0)`;

      requestAnimationFrame(animate);
    };

    const updateCursorPosition = (e) => {
      aimX = e.clientX;
      aimY = e.clientY;
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      const isClickable = 
        target.tagName.toLowerCase() === 'button' ||
        target.tagName.toLowerCase() === 'a' ||
        target.closest('.tool-card') ||
        target.closest('.nav-link') ||
        target.closest('.proj-imgbx') ||
        target.closest('.social-icon a');
      
      if (isClickable) {
        cursor.classList.add('cursor-hover');
        cursorDot.classList.add('cursor-dot-hover');
      }
    };

    const handleMouseOut = () => {
      cursor.classList.remove('cursor-hover');
      cursorDot.classList.remove('cursor-dot-hover');
    };

    document.addEventListener('mousemove', updateCursorPosition);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    animate();

    return () => {
      document.removeEventListener('mousemove', updateCursorPosition);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className="custom-cursor"></div>
      <div ref={cursorDotRef} className="cursor-dot"></div>
    </>
  );
}; 